import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ReportControl } from '@xmedical/core';

@Component({
  selector: 'xmed-image-field-renderer',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './image-field-renderer.component.html',
  styleUrl: './image-field-renderer.component.scss'
})
export class ImageFieldRendererComponent {
  control = input.required<ReportControl>();

  imageDataUrl = computed(() => {
    const data = this.control().imageBase64Data;
    const type = this.control().imageContentType;
    if (!data || !type) return null;
    return `data:${type};base64,${data}`;
  });
}
